import { IAjaxConfig } from '../libraries';
export class EnumApiLexiang {
  /**
   * @dec 乐享获取code
   */
  readonly lexiang_oauth_code_tokenAndAppId: IAjaxConfig = {
    url: '/api/gateway/bp-cultivate-lexiang/public/oauth/code/tokenAndAppId',
    method: 'post',
  };

  /**
   * @dec
   */
  readonly lexiang_privacy_agree: IAjaxConfig = {
    url: '/api/gateway/bp-cultivate-lexiang/public/privacy/agree',
    method: 'post',
  };
}
